import { Component, type ReactNode } from 'react';
import { BlockStack, Card, Typography } from '@pv-frontend/ui-components-web';

/** Shown in place of the Data health page when its query fails. */
export function DataHealthError() {
    return (
        <Card padding="500" testID="data-health-error">
            <BlockStack gap="150">
                <Typography variant="heading-sm" as="h2" fontWeight="semibold">
                    Could not load Data health
                </Typography>
                <Typography variant="body-sm" tone="text-secondary">
                    The Admin API did not return the freshness read model. Reload the page to try again.
                </Typography>
            </BlockStack>
        </Card>
    );
}

/** Catches a failed query (Relay throws it during render) and shows `DataHealthError` instead of a blank page. */
export class DataHealthErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
    override state = { failed: false };

    static getDerivedStateFromError() {
        return { failed: true };
    }

    override render() {
        return this.state.failed ? <DataHealthError /> : this.props.children;
    }
}
